import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { useShowCounterparty } from "@hooks/useShowCounterparty";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface Props {
    transaction: TransactionListItem;
    alwaysShowBankDescription?: boolean;
}

export const TransactionDescriptionContent: React.FC<Props> = ({
    transaction,
    alwaysShowBankDescription,
}) => {
    const showCounterparty = useShowCounterparty();
    const counterpartyToShow = showCounterparty(transaction.counterparty)
        ? transaction.counterparty
        : null;

    return (
        <Tooltip
            side="top"
            content={
                <>
                    {counterpartyToShow && (
                        <>
                            <span className="label">Counterparty</span>
                            <p className="mb-0">{counterpartyToShow.name}</p>
                        </>
                    )}
                    <span className="label">Bank description</span>
                    <p className="mb-0">{transaction.bankDescription}</p>
                </>
            }
        >
            <span>
                <BreakableText
                    text={
                        alwaysShowBankDescription
                            ? transaction.bankDescription
                            : (transaction.displayDescription ??
                              transaction.bankDescription)
                    }
                    showTooltip={false}
                />
            </span>
        </Tooltip>
    );
};
